import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Typography } from '../../../typography/Typography.mjs';
import { formFieldPlaceholder } from './placeholder.vanilla.mjs';

const FormFieldPlaceholder = forwardRef(
  ({
    className: classNameFromProps,
    color = "grayLight",
    weight = 500,
    ...props
  }, forwardedRef) => {
    const className = classNames(formFieldPlaceholder, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Typography,
      {
        "data-scope": "form-field",
        "data-part": "placeholder",
        className,
        color,
        weight,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FormFieldPlaceholder.displayName = "FormField.Placeholder";

export { FormFieldPlaceholder };
//# sourceMappingURL=Placeholder.mjs.map
